import Core from "Core";

export class LicensesStore extends Core.Stores.ModelStore {
  constructor(modelType, store) {
    super(modelType, "/api/public/licenses.php", store);
  }

  beforeUpdateFromJson() {
    this.clear();
  }

  fetchByCustomerId(customerId) {
    return this.fetch(`?customerId=${customerId}`);
  }
}



// WEBPACK FOOTER //
// ./src/Stores/DataStore/LicensesStore.js